import React from "react";
import classNames from "classnames";
import styles from "./SeleccionarProcesoAyuda.module.scss";
import Button from "../../components/UI/Button/Button";
import {URLs} from "../../util/Constants";
import {BreadcrumbsItem} from "react-breadcrumbs-dynamic";

export class SeleccionarProcesoAyuda extends React.Component<any, any> {
  render() {
    return (
      <div className="container-fluid">

        <BreadcrumbsItem to={URLs.SELECCIONAR_PROCESO + URLs.SELECCIONAR_PROCESO_AYUDA}>
          &iquest;Qu&eacute; proceso seleccionar?
        </BreadcrumbsItem>

        <div className={"row"}>
          <div className={"col-md-6 col-sm-12"}>

            <div className={styles.ColContainer}>

              <div className={styles.TitleContainer}>
                <h1 className={styles.Title}>No s&eacute; cu&aacute;l es el proceso que debo seleccionar</h1>
                <p className={styles.Description}>
                  A continuaci&oacute;n encontrar&aacute;s la descripci&oacute;n de cada proceso para
                  que puedas seleccionarlo de forma correcta:</p>
              </div>
              <br/>
              <p className={styles.SubTitle}>¿Recibiste una asesor&iacute;a por parte de Protecci&oacute;n para
                solicitar tu pensi&oacute;n o prestaci&oacute;n econ&oacute;mica?</p>
              <p className={styles.Content}>En Protecci&oacute;n, cuando tienes la intenci&oacute;n de solicitar tu
                pensi&oacute;n o prestaci&oacute;n econ&oacute;mica es necesario que as&iacute; lo manifiestes y recibas
                una asesor&iacute;a en una oficina o a trav&eacute;s de la l&iacute;nea de servicio al cliente. Si ya
                tuviste esta asesor&iacute;a y deseas radicar los documentos solicitados en la lista documental que
                te entregamos, selecciona <span className={classNames(styles.Italic)}>Solicitud de  
                  prestaci&oacute;n econ&oacute;mica o pensi&oacute;n</span> en la p&aacute;gina anterior,
                seg&uacute;n si tu solicitud es de <span className={classNames(styles.Italic)}>Vejez, Invalidez o 
                  Sobrevivencia.</span>
                </p>
              <p className={styles.Content}>Si debes entregar documentaci&oacute;n adicional a la solicitada
                inicialmente en tu solicitud de pensi&oacute;n, selecciona “Solicitud de documentos adicionales” 
                en la p&aacute;gina anterior.</p>
              <p className={styles.SubTitle}> ¿Debes entregar informaci&oacute;n de otros tr&aacute;mites no
                relacionados con solicitudes de Pensi&oacute;n?</p>
              <ul className={styles.Content}>
                <li>Si debes entregar documentos para completar una solicitud de Retiro de Cesant&iacute;as
                previamente iniciada por uno de nuestros canales, entonces selecciona “Solicitud de retiro de
                Cesant&iacute;as” en la p&aacute;gina anterior.
                  </li>
                <li>Si eres pensionado de Protecci&oacute;n y deber entregar documentos para soportar una novedad
                  de n&oacute;mina previamente reportada por uno de nuestros canales,
                  entonces selecciona “Solicitud para el ingreso de novedades de n&oacute;mina de pensionados”
                  en la p&aacute;gina anterior.
                </li>
              </ul>
              <br/>

              <div className={styles.SubmitButtonContainer}>
                <Button type="button"
                        name="volver"
                        typeStyle="primary"
                        height="40"
                        notFullWidth
                        onClick={this.goBack}>Volver</Button>
              </div>
            </div>

          </div>
          <div className={classNames("d-none d-md-block col-md-6", styles.BackgroundImage)}/>
        </div>
      </div>
    );

  }

  goBack = () => {
    const {history} = this.props;
    history.push(URLs.SELECCIONAR_PROCESO);
  }
}

export default SeleccionarProcesoAyuda;
